"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsPricePerSquareFootResponse$ = exports.StatsPricePerSquareFootResponse$outboundSchema = exports.StatsPricePerSquareFootResponse$inboundSchema = void 0;
exports.statsPricePerSquareFootResponseToJSON = statsPricePerSquareFootResponseToJSON;
exports.statsPricePerSquareFootResponseFromJSON = statsPricePerSquareFootResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelssalesnationalgetpricepersquarefootnationalresponsesstatspricepersquarefootwrapper_js_1 = require("./fastapikrakenendpointsstatsmodelssalesnationalgetpricepersquarefootnationalresponsesstatspricepersquarefootwrapper.js");
/** @internal */
exports.StatsPricePerSquareFootResponse$inboundSchema = z.object({
    data: fastapikrakenendpointsstatsmodelssalesnationalgetpricepersquarefootnationalresponsesstatspricepersquarefootwrapper_js_1.FastapiKrakenEndpointsStatsModelsSalesNationalGetPricePerSquareFootNationalResponsesStatsPricePerSquareFootWrapper$inboundSchema,
});
/** @internal */
exports.StatsPricePerSquareFootResponse$outboundSchema = z.object({
    data: fastapikrakenendpointsstatsmodelssalesnationalgetpricepersquarefootnationalresponsesstatspricepersquarefootwrapper_js_1.FastapiKrakenEndpointsStatsModelsSalesNationalGetPricePerSquareFootNationalResponsesStatsPricePerSquareFootWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsPricePerSquareFootResponse$;
(function (StatsPricePerSquareFootResponse$) {
    /** @deprecated use `StatsPricePerSquareFootResponse$inboundSchema` instead. */
    StatsPricePerSquareFootResponse$.inboundSchema = exports.StatsPricePerSquareFootResponse$inboundSchema;
    /** @deprecated use `StatsPricePerSquareFootResponse$outboundSchema` instead. */
    StatsPricePerSquareFootResponse$.outboundSchema = exports.StatsPricePerSquareFootResponse$outboundSchema;
})(StatsPricePerSquareFootResponse$ || (exports.StatsPricePerSquareFootResponse$ = StatsPricePerSquareFootResponse$ = {}));
function statsPricePerSquareFootResponseToJSON(statsPricePerSquareFootResponse) {
    return JSON.stringify(exports.StatsPricePerSquareFootResponse$outboundSchema.parse(statsPricePerSquareFootResponse));
}
function statsPricePerSquareFootResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsPricePerSquareFootResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsPricePerSquareFootResponse' from JSON`);
}
//# sourceMappingURL=statspricepersquarefootresponse.js.map